const BASE_DOMAIN = "https://dcapi.techpos.ca";
const POS_DOMAIN = "https://dcapi.techpos.ca";
const REPORTS_DOMAIN = "https://dcapi.techpos.ca";

const getDomain = (key) => {
    const storedUrl = localStorage.getItem('TECHPOS_ApiUrl');
    let apiUrls = (storedUrl && storedUrl !== "undefined") ? JSON.parse(storedUrl) : null;
    let domain = apiUrls !== null ? apiUrls[key] : null;
    let staticUrl = BASE_DOMAIN;
    if (key === 'apiUrl') {
        staticUrl = BASE_DOMAIN;
    } else if (key === 'posUrl') {
        staticUrl = POS_DOMAIN;
    } else if (key === 'reportUrl') {
        staticUrl = REPORTS_DOMAIN;
    }
    return domain !== null ? domain : staticUrl;
};

const getCompanyCode = () => {
    return localStorage.getItem('TECHPOS_CompanyCode') || 'initial';
};

const getFrontendBaseFolderName = () => {
    return JSON.parse(localStorage.getItem('TECHPOS_FolderName')) || null
}

const getBaseDomain = () => getDomain('apiUrl');
const getPOSDomain = () => getDomain('posUrl');
const getReportDomain = () => getDomain('reportUrl');
const getIntegrationDomain = () => getDomain('integrationUrl');

const getBaseUrl = () => `${getBaseDomain()}/${getCompanyCode()}/api/`;
const getPOSUrl = () => `${getPOSDomain()}/${getCompanyCode()}/api/`;
const getReportUrl = () => `${getReportDomain()}/${getCompanyCode()}/api/`;
const getIntegrationUrl = () => `${getIntegrationDomain()}/${getCompanyCode()}/api/`;
const getFrontendBaseFolder = () => getFrontendBaseFolderName();

export default {
    baseUrl: getBaseUrl,
    posAPIUrl: getPOSUrl,
    reportsAPIUrl: getReportUrl,
    integrationUrl: getIntegrationUrl,
    frontendBaseFolder: getFrontendBaseFolder
};